import React from 'react';
import Select from '@powerednow/components/fields/Select';
import {
    MenuItem, FormControl,
} from '@mui/material';

import { INTEGRATION } from '@powerednow/shared/constants';
import Box from '@powerednow/components/Box/Box';

export default function CategorySelector({
    item, mapping, onChange, xeroIntegration,
}) {
    return (
        <Box sx={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
            <Select
                sx={theme => ({
                    mb: 0, width: 'min(max(100px, 25vw), 400px)',
                })}
                value={mapping?.[item.id]?.salesCode || ''}
                clearable
                displayEmpty
                onChange={e => {
                    const newMapping = { ...mapping };
                    newMapping[item.id] = { ...newMapping[item.id], salesCode: e.target.value };
                    onChange(newMapping);
                }}
            >
                <MenuItem value="">Default</MenuItem>
                {xeroIntegration.settings.accountCodeChoices[INTEGRATION.ACCOUNT_CODE_TYPES.SALES].map(option => (
                    <MenuItem key={option.code} value={option.code}>
                        {`${option.code} - ${option.name}`}
                    </MenuItem>
                ))}
            </Select>
            <Select
                sx={{ mb: 0, ml: 5, width: 'min(max(100px, 25vw), 400px)' }}
                value={mapping?.[item.id]?.costCode || ''}
                clearable
                displayEmpty
                onChange={e => {
                    const newMapping = { ...mapping };
                    newMapping[item.id] = { ...newMapping[item.id], costCode: e.target.value };
                    onChange(newMapping);
                }}
            >
                <MenuItem value="">Default</MenuItem>
                {xeroIntegration.settings.accountCodeChoices[INTEGRATION.ACCOUNT_CODE_TYPES.SUPPLIER_INVOICES].map(option => (
                    <MenuItem key={option.code} value={option.code}>
                        {`${option.code} - ${option.name}`}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
}
